import {
  PaymentGatewayIcon,
  WireIcon,
  AppStoreIcon,
  TellerIcon,
  SmartXIcon,
  FormFeeIcon,
  PaymentLinkIcon,
  SmartBillingIcon,
  InstacollectIcon
} from 'utils/icons';

const PARTNER_PRODUCTS = {
  easepay_allowed: {
    label: 'Payment Link',
    color: '#DD0000',
    bgColor: '#FFE8E8',
    icon: <PaymentLinkIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  pay_easebuzz_allowed: {
    label: 'Payment Gateway',
    color: '#DD0000',
    bgColor: '#FFE8E8',
    icon: <PaymentGatewayIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  wire_allowed: {
    label: 'Wire',
    color: '#00E874',
    bgColor: '#E2FFF0',
    icon: <WireIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  edu_allowed: {
    label: 'Forms and Fees',
    color: '#DD0000',
    bgColor: '#FFE8E8',
    icon: <FormFeeIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  smartx_allowed: {
    label: 'SmartX',
    color: '#00E874',
    bgColor: '#E2FFF0',
    icon: <SmartXIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  teller_allowed: {
    label: 'Teller',
    color: '#DD0000',
    bgColor: '#FFE8E8',
    icon: <TellerIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  invoicing_b2b_allowed: {
    label: 'Smart Billing',
    color: '#0A9305',
    bgColor: '#EDFFED',
    icon: <SmartBillingIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  instacollect_allowed: {
    label: 'Instacollect',
    color: '#0A9305',
    bgColor: '#EDFFED',
    icon: <InstacollectIcon style={{ fontSize: '30px' }} />,
    show: true
  },
  stores_allowed: {
    label: 'App Store',
    color: '#0A9305',
    bgColor: '#EDFFED',
    icon: <AppStoreIcon style={{ fontSize: '30px' }} />,
    show: false
  },
  partner_allowed: {
    label: 'Partner Portal',
    color: '#CE841E',
    bgColor: '#FDEBD3',
    icon: <WireIcon style={{ fontSize: '30px' }} />,
    show: false
  },
  referral_module_allowed: {
    label: 'CALCULATING',
    color: '#719DFF',
    bgColor: '#D8E4FF',
    icon: <WireIcon style={{ fontSize: '30px' }} />,
    show: false
  },
  loans_allowed: {
    label: 'Loans',
    color: '#CE841E',
    bgColor: '#FDEBD3',
    icon: <WireIcon style={{ fontSize: '30px' }} />,
    show: false
  }
};

const BUTTON_PRODUCT_STATUS = {
  0: {
    label: 'Active',
    color: '#60D271',
    bgColor: '#D7F4DC',
    brColor: '#D7F4DC',
    hovercolor: '#60D271',
    hoverbgColor: '#D7F4DC',
    hoverbrColor: '#D7F4DC'
  },
  1: {
    label: 'Raise Request',
    color: 'white',
    bgColor: 'var(--color-primary) ',
    brColor: '#FFE8E8',
    hovercolor: 'white',
    hoverbgColor: '#946ff2',
    hoverbrColor: '#946ff2'
  },
  2: {
    label: 'Requested',
    color: '#DBA757',
    bgColor: '#F2DEC0',
    brColor: '#FFE8E8',
    hovercolor: '#DBA757',
    hoverbgColor: '#F2DEC0',
    hoverbrColor: '#FFE8E8'
  }
};
export { PARTNER_PRODUCTS, BUTTON_PRODUCT_STATUS };
